import { RowData } from '../types';

export const invalidHighscore = (address: string) => {
  // cannot use NaN; sort fails with it
  return { place: 6969, address: address, collection: 'invalid', nft_id: 6969, score: 6969 };
};

export function createLobbyRowData(place: number, address: string, nft: string, score: number): RowData {
  const nft_parts = nft.split('#');

  if (nft_parts.length > 1) {
    const collection: string = nft_parts[0];
    const nft_id: number = +nft_parts[1];
    if (!isNaN(nft_id)) return { place, address, collection, nft_id, score };
    return invalidHighscore(address);
  }
  return invalidHighscore(address);
}

